/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_ResetInputs */

const vi_sidebar_layout_reset = /** @type {(inputs: Sidebar_Layout_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khôi phục mặc định`)
};

/**

* @param {Sidebar_Layout_ResetInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_reset = /** @type {((inputs?: Sidebar_Layout_ResetInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_ResetInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_reset(inputs)
});